import { render, staticRenderFns } from "./MatchSelect.vue?vue&type=template&id=1062a844&"
import script from "./MatchSelect.vue?vue&type=script&lang=js&"
export * from "./MatchSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports